/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { apiCall } from './api'

export const GET_SPOTIFY_ACCESS_TOKEN = createAsyncAction(
  'GET_SPOTIFY_ACCESS_TOKEN'
)
export const getSpotifyAccessToken = (isAdmin: boolean, callback: () => void) =>
  apiCall({
    method: 'post',
    endpoint: '/auth/access-spotify-token',
    query: {
      isAdmin,
    },
    types: GET_SPOTIFY_ACCESS_TOKEN,
    callback,
  })

export const GET_FREE_SPOTIFY_ACCESS_TOKEN = createAsyncAction(
  'GET_FREE_SPOTIFY_ACCESS_TOKEN'
)
export const getFreeSpotifyAccessToken = (callback: () => void) =>
  apiCall({
    method: 'get',
    endpoint: '/auth/free-access-spotify-token',
    types: GET_FREE_SPOTIFY_ACCESS_TOKEN,
    callback,
  })
